import { createEnv } from "@t3-oss/env-core";
import { z } from "zod";

export const env = createEnv({
  server: {
    SERVER_URL: z.string().url().optional(),
    // Better Auth
    BETTER_AUTH_SECRET: z.string().min(32).optional(),
    // Better Auth - Social Providers
    BETTER_AUTH_URL: z.string().url().optional(),
    GOOGLE_CLIENT_ID: z.string().optional(),
    GOOGLE_CLIENT_SECRET: z.string().optional(),
    FACEBOOK_CLIENT_ID: z.string().optional(),
    FACEBOOK_CLIENT_SECRET: z.string().optional(),
    // SurrealDB Configuration
    SURREALDB_URL: z.string().url().default("http://localhost:8000"),
    SURREALDB_NAMESPACE: z.string().default("toolverse"),
    SURREALDB_DATABASE: z.string().default("main"),
    SURREALDB_USERNAME: z.string().default("root"),
    SURREALDB_PASSWORD: z.string().default("root"),
    // Polar.sh
    POLAR_ACCESS_TOKEN: z.string().optional(),
    POLAR_ORGANIZATION_ID: z.string().optional(),
    POLAR_PRODUCT_ID_MONTHLY: z.string().optional(),
    POLAR_PRODUCT_ID_ANNUAL: z.string().optional(),
    POLAR_WEBHOOK_SECRET: z.string().optional(),
    // Discord webhooks for contact submissions (optional — no-op if unset).
    // These are webhook URLs (https://discord.com/api/webhooks/...), NOT invite links.
    DISCORD_IDEA_WEBHOOK_URL: z.string().url().optional(),
    DISCORD_BUG_WEBHOOK_URL: z.string().url().optional(),
  },

  /**
   * The prefix that client-side variables must have. This is enforced both at
   * a type-level and at runtime.
   */
  clientPrefix: "VITE_",

  client: {
    VITE_APP_TITLE: z.string().min(1).optional(),
    // Google AdSense
    VITE_ADSENSE_PUBLISHER_ID: z.string().optional(),
    VITE_ADSENSE_DISPLAY_SLOT: z.string().optional(),
    VITE_ADSENSE_REWARDED_SLOT: z.string().optional(),
    // Sentry
    VITE_SENTRY_DSN: z.string().url().optional(),
    // Polar.sh — set to "true" once Polar is configured
    VITE_POLAR_ENABLED: z.string().optional(),
    // Google Analytics 4
    VITE_GA_MEASUREMENT_ID: z.string().optional(),
  },

  /**
   * What object holds the environment variables at runtime. This is usually
   * `process.env` or `import.meta.env`.
   */
  runtimeEnv: import.meta.env,

  /**
   * By default, this library will feed the environment variables directly to
   * the Zod validator.
   *
   * This means that if you have an empty string for a value that is supposed
   * to be a number (e.g. `PORT=` in a ".env" file), Zod will incorrectly flag
   * it as a type mismatch violation. Additionally, if you have an empty string
   * for a value that is supposed to be a string with a default value (e.g.
   * `DOMAIN=` in an ".env" file), the default value will never be applied.
   *
   * In order to solve these issues, we recommend that all new projects
   * explicitly specify this option as true.
   */
  emptyStringAsUndefined: true,
});
